interface Props {
  value: number;
  max?: number;
  label?: string;
  variant?: 'default' | 'mastery';
}

export function ProgressBar({ value, max = 100, label, variant = 'default' }: Props) {
  const pct = Math.max(0, Math.min(100, (value / max) * 100));
  return (
    <div className={`progress progress-${variant}`}>
      {label && (
        <div className="progress-label">
          <span>{label}</span>
          <span>{Math.round(pct)}%</span>
        </div>
      )}
      <div className="progress-track">
        <div className="progress-fill" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
